import { Component } from "react";
import { withRouter } from "react-router-dom";
import { SOCKET_RTC_URL } from "../utils/Constants";

class ScreenShare extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roomId: '',
            isChatOpened: false,
            chat: [],
            message: '',
            isMute: false,
            isVideoMute: false,
            unreadMessageCount: 0,
            isZoom: true,
            videoStream: [],
        }
        this._notifiedShare = false;
        this._joinRetryTimer = null;
    }

    componentDidMount() {
        this.loadVideoConferencing();
    }

    componentWillUnmount() {
        if (this._joinRetryTimer) {
            clearTimeout(this._joinRetryTimer);
            this._joinRetryTimer = null;
        }
        try {
            if (this.connection) {
                this.connection.onstream = () => {};
                this.connection.onstreamended = () => {};
                this.connection.onMediaError = () => {};
                if (typeof this.connection.attachStreams !== 'undefined') {
                    (this.connection.attachStreams || []).forEach((stream) => {
                        try {
                            stream.getTracks().forEach((t) => t.stop());
                        } catch (e) { /* ignore */ }
                    });
                }
                this.connection.close && this.connection.close();
                this.connection = null;
            }
        } catch (e) {
            /* ignore */
        }
        // Remove any leftover screen-share tiles from the call container
        try {
            document.querySelectorAll(
                '#videos-container .media-container.screen-share, #videos-container .media-container.screen-share-local'
            ).forEach((node) => {
                if (node.parentNode) node.parentNode.removeChild(node);
            });
        } catch (e) {
            /* ignore */
        }
    }

    joinVideConferencing = () => {
        const { roomId, share, view } = this.props;
        if (!this.connection || !roomId) {
            return false;
        }
        if (share) {
            this.connection.open(roomId);
            return;
        }
        if (view) {
            this.connection.checkPresence(roomId, (isRoomExist) => {
                if (!this.connection) return;
                if (isRoomExist) {
                    this.connection.join(roomId);
                    return;
                }
                this._joinRetryTimer = setTimeout(() => {
                    this.joinVideConferencing();
                }, 2000);
            });
        }
    }

    loadVideoConferencing = () => {
        const { share, view, roomId } = this.props;
        if (!roomId) {
            return;
        }
        this.connection = new global.RTCMultiConnection();
        this.connection.socketURL = SOCKET_RTC_URL;
        this.connection.socketMessageEvent = 'screen-sharing-demo';

        this.connection.session = {
            screen: true,
            oneway: true
        };

        // Sharer sends only; viewer must be able to receive the screen track
        this.connection.sdpConstraints.mandatory = {
            OfferToReceiveAudio: false,
            OfferToReceiveVideo: !!view
        };

        this.connection.videosContainer = document.getElementById('videos-container');
        this.connection.onstream = (event) => {
            var existing = document.getElementById(event.streamid);
            if (existing && existing.parentNode) {
                existing.parentNode.removeChild(existing);
            }
            if (share && !this._notifiedShare) {
                this._notifiedShare = true;
                this.props.onScreenShared(roomId);
            }

            event.mediaElement.removeAttribute('src');
            event.mediaElement.removeAttribute('srcObject');
            event.mediaElement.muted = true;
            event.mediaElement.volume = 0;

            var video = document.createElement('video');

            try {
                video.setAttributeNode(document.createAttribute('autoplay'));
                video.setAttributeNode(document.createAttribute('playsinline'));
            } catch (e) {
                video.setAttribute('autoplay', true);
                video.setAttribute('playsinline', true);
            }
            const isLocal = event.type === 'local';
            if (isLocal) {
                video.volume = 0;
                try {
                    video.setAttributeNode(document.createAttribute('muted'));
                } catch (e) {
                    video.setAttribute('muted', true);
                }
                video.muted = true;
            }
            video.srcObject = event.stream;

            var mediaElement = global.getHTMLMediaElement(video, {
                buttons: [],
                showOnMouseEnter: false
            }, isLocal, false, true);

            if (this.connection && this.connection.videosContainer) {
                this.connection.videosContainer.appendChild(mediaElement);
            }

            setTimeout(function () {
                try {
                    mediaElement.media && mediaElement.media.play && mediaElement.media.play();
                } catch (e) { /* ignore */ }
            }, 300);

            mediaElement.id = event.streamid;
            // Mark track ended (user clicks browser "Stop sharing")
            try {
                const track = event.stream.getVideoTracks && event.stream.getVideoTracks()[0];
                if (track) {
                    track.onended = () => {
                        if (share && this.props.onStopScreenShare) {
                            this.props.onStopScreenShare();
                        }
                    };
                }
            } catch (e) { /* ignore */ }
        };

        this.connection.onstreamended = (event) => {
            var mediaElement = document.getElementById(event.streamid);
            if (mediaElement && mediaElement.parentNode) {
                mediaElement.parentNode.removeChild(mediaElement);
            }
            // Only the sharer should notify/stop the session
            if (share && this.props.onStopScreenShare) {
                this.props.onStopScreenShare();
            }
        };

        this.connection.onMediaError = (e) => {
            if (share && this.props.onStopScreenShare) {
                this.props.onStopScreenShare();
            }
            if (e && e.message === 'Concurrent mic process limit.') {
                if (global.DetectRTC.audioInputDevices.length <= 1) {
                    alert('Please select external microphone. Check github issue number 483.');
                    return;
                }
                var secondaryMic = global.DetectRTC.audioInputDevices[1].deviceId;
                this.connection.mediaConstraints.audio = {
                    deviceId: secondaryMic
                };
                this.connection.join(this.connection.sessionid);
            }
        };

        this.joinVideConferencing();
    }

    render() {
        return null;
    }
}

export default withRouter(ScreenShare);
